import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ReviewModal = ({
  open,
  title,
  subtitle,
  initialRating = 0,
  initialComment = '',
  onClose,
  onSubmit,
  saving,
  submitLabel,
}) => {
  const { t } = useTranslation();
  const [rating, setRating] = useState(initialRating);
  const [comment, setComment] = useState(initialComment);
  const [hover, setHover] = useState(0);

  useEffect(() => {
    if (open) {
      setRating(initialRating);
      setComment(initialComment);
    }
  }, [open, initialRating, initialComment]);

  if (!open) return null;

  const displayRating = hover || rating;

  return (
    <>
      <div className="fixed inset-0 z-50 bg-black/60" onClick={onClose} />
      <div className="fixed left-1/2 top-1/2 z-50 w-[calc(100%-2rem)] max-w-md -translate-x-1/2 -translate-y-1/2 rounded-xl border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900 p-6">
        <h2 className="text-lg font-semibold">{title || t('reviews.leaveReview')}</h2>
        {subtitle && <p className="mt-1 text-sm text-zinc-600 dark:text-zinc-500">{subtitle}</p>}

        <div className="mt-6 flex justify-center gap-2">
          {[1, 2, 3, 4, 5].map((star) => (
            <button
              key={star}
              type="button"
              onMouseEnter={() => setHover(star)}
              onMouseLeave={() => setHover(0)}
              onClick={() => setRating(star)}
              className={`text-3xl transition ${star <= displayRating ? 'text-amber-400' : 'text-zinc-400 dark:text-zinc-600'}`}
            >
              ★
            </button>
          ))}
        </div>
        {displayRating > 0 && (
          <p className="mt-2 text-center text-sm text-amber-300/80">
            {t(`reviews.ratingLabels.${displayRating}`)}
          </p>
        )}

        <textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder={t('reviews.experienceOptional')}
          rows={4}
          className="mt-4 w-full rounded-lg border border-zinc-300 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-950 px-3 py-2 text-sm"
        />

        <div className="mt-6 flex gap-3">
          <button type="button" onClick={onClose} className="flex-1 rounded-lg border border-zinc-300 dark:border-zinc-700 py-2 text-sm">
            {t('common.cancel')}
          </button>
          <button
            type="button"
            disabled={!rating || saving}
            onClick={() => onSubmit({ rating, comment })}
            className="flex-1 rounded-lg bg-glow-600 py-2 text-sm text-white disabled:opacity-50"
          >
            {saving ? t('reviews.submitting') : submitLabel || t('reviews.submitReview')}
          </button>
        </div>
      </div>
    </>
  );
};

export default ReviewModal;
